import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { secureAssetUrl } from "../../lib/secureUrl";

const NOTION_COLOR = {
  gray: "#9b9b9b",
  brown: "#a17c5b",
  orange: "#d9730d",
  yellow: "#dfab01",
  green: "#ACD6BA",
  blue: "#5b9bd5",
  purple: "#9a6dd7",
  pink: "#e255a1",
  red: "#e35b5b",
};

const spanStyle = (s) => {
  const style = {};
  if (s.color && s.color !== "default") {
    if (s.color.endsWith("_background")) {
      style.backgroundColor = NOTION_COLOR[s.color.replace("_background", "")] || "transparent";
      style.padding = "0 4px";
    } else {
      style.color = NOTION_COLOR[s.color];
    }
  }
  return style;
};

const isUntitledLabel = (text) => {
  const t = (text || "").trim().toLowerCase();
  return !t || t === "untitled" || t === "sans titre";
};

const Span = ({ s }) => {
  const { resolveRef, resolvePageTitle } = useSite();
  const internal = s.page_ref ? resolveRef(s.page_ref) : null;
  const resolvedTitle = s.page_ref ? resolvePageTitle(s.page_ref) : null;
  const label =
    internal && isUntitledLabel(s.text) && resolvedTitle ? resolvedTitle : s.text;

  // Mention to an out-of-scope Notion page: hide the "Untitled" noise (per PRD).
  if (s.page_ref && !internal) {
    if (isUntitledLabel(s.text)) return null;
    return <span>{s.text}</span>;
  }

  let content = label;

  if (s.code) {
    content = (
      <code className="bg-pillet-forest/60 text-pillet-sage px-1.5 py-0.5 font-mono text-[0.85em]">
        {label}
      </code>
    );
  }

  let node = (
    <span
      style={spanStyle(s)}
      className={[
        s.bold ? "font-bold text-white" : "",
        s.italic ? "italic" : "",
        s.underline ? "underline" : "",
        s.strikethrough ? "line-through" : "",
      ].join(" ")}
    >
      {content}
    </span>
  );

  if (internal) {
    return (
      <Link
        to={internal}
        data-testid="internal-link"
        className="text-pillet-sage underline underline-offset-2 hover:text-white transition-colors"
      >
        {node}
      </Link>
    );
  }
  if (s.href) {
    return (
      <a
        href={secureAssetUrl(s.href)}
        target="_blank"
        rel="noopener noreferrer"
        className="text-pillet-sage underline underline-offset-2 hover:text-white transition-colors"
      >
        {node}
      </a>
    );
  }
  return node;
};

const RichText = ({ spans }) => {
  if (!spans || spans.length === 0) return null;
  return (
    <>
      {spans.map((s, i) => (
        <Span key={i} s={s} />
      ))}
    </>
  );
};

export default RichText;
